import { store, getContext, getElement, useState, useEffect } from "@wordpress/interactivity";

console.log('outcome');

function splitString(inputString) {
  const regex = /(.*?)(\d+)(.*)/;
  const match = inputString.match(regex);
  if (match) {
    return {
      prefix: match[1],
      number: parseInt(match[2], 10),
      postfix: match[3]
    };
  } else {
    return null;
  }
}

const { state, actions, callbacks } = store('frs-blocks/outcomes--column', {
  state: {},
  actions: {},
  callbacks: {
    initialize: (e) => {
      /*
      const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
      if(prefersReducedMotion.matches) return;

      const outcome = getElement().ref.querySelector('.counter');
      if(outcome)
      {
        var parts = splitString(outcome.innerHTML);
        if(parts)
        {
          outcome.dataset.type = 'outcome';
          outcome.dataset.triggered = false;
          outcome.dataset.goal = parts.number;
          outcome.dataset.prefix = parts.prefix;
          outcome.dataset.postfix = parts.postfix;
          outcome.innerHTML = `${parts.prefix}0${parts.postfix}`
          intersectionObserver.observe(outcome);
        }
      }
      */
    }
  }
});
